<template>
  <div class="directory-list">
    <div class="mb-4">
      <h4 class="mb-2 title-new">Partner Directory</h4>
      <div class="text-center banner py-2">
        <h4>Just Launched</h4>
        <span>The Global Partner Network – Be Seen. Be Heard. Be Global.</span>
        <span class="d-block">Keep checking - more partners are joining now…</span>
        <span>
          Showcase your brand –
          <a href="/tfm/enquiry-form">Enquire here</a>
        </span>
      </div>

      <div class="row">
        <div v-for="(partner, index) in filteredPartners" :key="index" class="col-sm-6 col-md-4 col-lg-3 d-flex p-2">
          <CCard class="h-100 w-100 d-flex flex-column">
            <CCardHeader class="border-bottom-0">
              <CRow>
                <CCol md="12">
                  <img :src="partner.logo" alt="Partner Logo" class="partner-logo" />
                </CCol>
              </CRow>

              <p class="font-weight-bold mb-2 mt-3">
                {{ partner.name }}
              </p>

            </CCardHeader>

            <CCardBody class="pt-0 flex-grow-1 pb-0 d-flex flex-column">

              <div class="partner-card flex-grow-1">

                <p class="small text-muted" v-if="partner.description">

                  {{ truncateText(partner.description) }}

                  <a v-if="partner.description.length > 120" href="#" class="read-link"
                    @click.prevent="openDescription(partner)">
                    Read More...
                  </a>

                </p>

              </div>

            </CCardBody>

            <CCardFooter class="border-top-0">

              <div>

                <div>

                  <CBadge color="info" shape="pill" class="px-2 py-1" v-if="partner.badge.length > 0">
                    {{ partner.badge[0] }}
                  </CBadge>

                  <CBadge class="px-2 py-1 position-relative" v-if="partner.badge.length > 1"
                    @mouseover="tooltipIndex = index" @mouseleave="tooltipIndex = null">

                    +{{ partner.badge.length - 1 }}

                    <div v-if="tooltipIndex === index" class="tooltip-badge-list">

                      <div class="badge-wrap">

                        <CBadge v-for="(badge, i) in additionalBadges(partner)" :key="i" :color="getBadgeColor(i)"
                          shape="pill" class="px-2 py-1 mb-1">
                          {{ badge }}
                        </CBadge>
                      </div>
                    </div>
                  </CBadge>
                </div>
                <div class="mt-3 text-center">

                  <CButton color="info" class="w-100" @click="partner.enable ? viewPartnerInfo(partner) : null">
                    View Profile
                  </CButton>
                </div>
              </div>
            </CCardFooter>
          </CCard>
        </div>
      </div>

      <div v-if="filteredPartners.length === 0">
        <h3 class="text-center text-muted">No Data found!</h3>
      </div>

      <CRow class="mt-3">
        <CCol md="12" class="d-flex justify-content-end">
          <Pagination
            :total="total"
            :perPage="perPage"
            @pagechanged="pagechanged"
            position="center"
          />
        </CCol>
      </CRow>

    </div>
    <CModal color="primary" :show.sync="showModal" size="lg" centered :close-on-backdrop="true">
      <template #header>
        <h6 class="modal-title">
          Partner Description for {{ selectedPartner?.name }}
        </h6>
        <CButtonClose @click="closeDescriptionModal" />
      </template>

      <div class="partner-modal-content">
        <div class="partner-modal-description" v-html="selectedPartner?.description"></div>
      </div>

      <template #footer>
        <CButton color="primary" variant="outline" class="px-4" @click="closeDescriptionModal">
          Close
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import { BASE_URL } from "@/service_urls";
import Modal from "@/components/reusable/Modal";
import Pagination from "@/components/reusable/Pagination";
export default {

  name: "DirectoryList",

  components: {
    Modal,
    Pagination
  },

  props: ["filterData"],

  data() {

    return {

      tooltipIndex: null,
      showModal: false,
      selectedPartner: null,
      page: 1,
      perPage: 10,
      total: 0,
// partners: [
      //   {
      //     id: "slc",
      //     name: "Specialist Language Courses",
      //     cardInitials: "SLC",
      //     logo: "/img/stm/slc_logo.png",
      //     description:
      //       "<b>Specialist Language Courses</b> (SLC) is a UK-based provider of online English training tailored for global healthcare professionals",
      //     backgroundColor: "#1e78ed",
      //     gradientColor: "linear-gradient(135deg, #1FA2FF, #12D8FA)",
      //     badge: [
      //       "Education",
      //       "Language",
      //       "OSCE",
      //       "Preparation",
      //       "Online",
      //       "Classroom",
      //       "Hybrid",
      //     ],
      //     region:['Western Europe/EU']
      //   },
      //   {
      //     id: "eintegrity",
      //     name: "eIntegrity",
      //     cardInitials: "eInt",
      //     logo: "/img/stm/eintegrity_logo.png",
      //     description:
      //       "<b>eIntegrity</b> is a global licensor of health and care elearning programmes developed by the NHS and the UK's professional bodies.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education", "Clinical Skills", "CPD", "Online"],
      //     region:['Western Europe/EU']
      //   },
      //   {
      //     id: "meros_pharm",
      //     name: "Meros Pharm",
      //     cardInitials: "Meros",
      //     logo: "/img/stm/meros.png",
      //     description:
      //       "<b>Meros Pharm</b> is a pharmaceutical distribution company dedicated to enhancing healthcare by providing high-quality medicines and healthcare products",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Pharma", "Education", "Hospital", "Supplier"],
      //     region:['Asia'],
      //   },
      //   {
      //     id: "meros_pharm",
      //     name: "Meros Pharmacies",
      //     cardInitials: "Meros",
      //     logo: "/img/stm/meros_pharmacies.png",
      //     description:
      //       "<b>Meros Pharmacies</b> produce, import, and distribute medicines and medical products through its widespread network of pharmacies.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Pharma"],
      //     region:['Asia']
      //   },
      //   {
      //     id: "meros_academy",
      //     name: "Meros Academy",
      //     cardInitials: "Meros",
      //     logo: "/img/stm/meros_academy.png",
      //     description:
      //       "<b>Meros Academy</b> is an educational center focused on the training and advanced training of specialists in the pharmaceutical industry.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education"],
      //     region:['Asia'],
      //   },
      //   {
      //     id: "meros_hospital",
      //     name: "Meros Hospital",
      //     cardInitials: "Meros",
      //     logo: "/img/stm/meros_hospital.png",
      //     description:
      //       "<b>Meros Hospital</b> is a modern medical center where patient care is combined with high professionalism and a personalized approach.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Hospital"],
      //     region:['Asia'],
      //   },
      //   {
      //     id: "scfhs",
      //     name: "Saudi Commission for Health Specialties",
      //     cardInitials: "SCFHS",
      //     logo: "/img/stm/saudi_logo.png",
      //     description:
      //       "<b>Saudi Commission for Health Specialties</b> regulates and accredits healthcare professionals in Saudi Arabia, promoting excellence through licensing, education, and continuous development",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Governmental", "Regulatory", "Education"],
      //     region:['Middle East'],
      //   },
      //   {
      //     id: "reem",
      //     name: "Reem",
      //     cardInitials: "Reem",
      //     logo: "/img/stm/reem_logo.png",
      //     description:
      //       "<b>Reem Hospital Abu Dhabi</b>, is a modern multi-specialty facility in Abu Dhabi offering post-acute rehabilitation and patient-centered care across 30+ disciplines, operated in partnership with Germany’s Charité Hospital",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Hospital"],
      //     region:['Middle East'],
      //   },
      //   {
      //     id: "hmg",
      //     name: "Sulaiman",
      //     cardInitials: "Sulaiman",
      //     logo: "/img/stm/sulaiman_logo.png",
      //     description:
      //       "<b>Dr. Sulaiman Al Habib Medical Group</b> is the GCC’s largest private healthcare provider, delivering innovative, AI-powered care across 25+ facilities and key specialties like cardiology, oncology, and fertility.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Hospital"],
      //     region:['Middle East'],
      //   },
      //   {
      //     id: "sensations",
      //     name: "Sensations",
      //     cardInitials: "Sensations",
      //     logo: "/img/stm/sensations_logo.png",
      //     description:
      //       "<b>Sensations English</b> offers up-to-date English lessons using international news videos and articles at five levels, with interactive games and resources for learners, teachers, schools, and businesses worldwide",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education"],
      //     enable: false,
      //     region:['Western Europe/EU']
      //   },
      //   {
      //     id: "nhs",
      //     name: "NHS England",
      //     cardInitials: "NHS",
      //     logo: "/img/stm/nhs_logo.png",
      //     description:
      //       "<b>NHS England</b> leads the National Health Service in England, ensuring high-quality, free healthcare for all, supporting staff, overseeing services, and driving innovation to improve the nation’s health and wellbeing.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Governmental"],
      //     enable: false,
      //     region:['Western Europe/EU']
      //   },
      //   {
      //     id: "infylearn",
      //     name: "INFYLEARN",
      //     cardInitials: "INFYLEARN",
      //     logo: "/img/stm/infylearn-logo.png",
      //     description:
      //       "<b>Vera</b> by <b>INFYLEARN</b> uses AI to simulate recruiter interviews, offering personalized insights to boost student confidence and placement success. It also helps healthcare recruiters with consistent, data-driven evaluations",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education"],
      //     enable: false,
      //     region:['Asia']
      //   },
      //   {
      //     id: "boost",
      //     name: "Boost",
      //     cardInitials: "Boost",
      //     logo: "/img/stm/boost.png",
      //     description:
      //       "<b>Boost</b> empowers healthcare students to master maths and core science skills through engaging video tutorials, interactive practice, and on-demand support - building confidence and readiness for clinical training.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education"],
      //     enable: false,
      //     region:['Western Europe/EU']
      //   },        
      //   {
      //     id: "beyondlabz",
      //     name: "BeyondLabz",
      //     cardInitials: "BeyondLabz",
      //     logo: "/img/stm/beyond-labz.png",
      //     description:
      //       "<b>BeyondLabz</b> brings science learning to life with immersive virtual labs in chemistry, biology, and physics - helping healthcare and life science students build real-world practical skills.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education"],
      //     enable: false,
      //     region:['North America']
      //   },
      //   {
      //     id: "near-life-tech",
      //     name: "Near-Life Tech",
      //     cardInitials: "Near-Life Tech",
      //     logo: "/img/stm/near-life-tech.png",
      //     description:
      //       "<b>Near-Life Tech</b> empowers users to create immersive, interactive video, VR, and instructional guides that enhance learning, improve engagement, and make education and training more accessible across platforms..",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Education"],
      //     enable: false,
      //     region:['Western Europe/EU']
      //   },
      //   {
      //     id: "thb",
      //     name: "THB",
      //     cardInitials: "THB",
      //     logo: "/img/stm/thb.png",
      //     description:
      //       "THB is Asia’s leading enterprise healthcare SaaS company, enabling digital transformation for large healthcare providers. Its platform processes 500M+ clinical data points across 20+ use cases, including engagement, CRM, automation, analytics, and real-world evidence generation.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Supplier"],
      //     enable: false,
      //     region:['Asia','Middle East']
      //   },
      //   {
      //     id: "gmc-services-international",
      //     name: "GMC Services International",
      //     cardInitials: "GMC Services International",
      //     logo: "/img/stm/gmc.png",
      //     description:
      //       "<b>GMC Services International (GMCSI)</b> is a wholly owned GMC subsidiary offering global consultancy to improve patient safety. It provides expert guidance on medical training, regulation, and tailored solutions based on the UK’s world-leading healthcare standards.",
      //     backgroundColor: "#1db956",
      //     gradientColor: "linear-gradient(135deg, #00C853, #00E676)",
      //     badge: ["Governmental"],
      //     enable: false,
      //     region:['Western Europe/EU']
      //   },
      // ],
    };
  },

  computed: {

    ...mapGetters(["getPartnerList"]),

    partners() {

      const baseUrl = BASE_URL.replace("/api/v1", "");

      return this.getPartnerList?.map((v) => ({
        id: v.customer_uid,
        name: v.name,
        logo: v.partner_logo
          ? `${baseUrl}${v.partner_logo.file_path}`
          : null,
        description: v.quick_description,
        badge: v.tags || [],
        region: v.region_name,
        enable: !!v.partner_documents?.file_path,
        doc_link: v.partner_documents
      })) || [];

    },

    filteredPartners() {

      let partners = this.partners;

      if (this.filterData?.classifications?.length) {

        partners = partners.filter((partner) =>
          this.filterData.classifications.some((badge) =>
            partner.badge.includes(badge)
          )
        );

      }

      if (this.filterData?.find_partner) {

        const value = this.filterData.find_partner.toLowerCase();

        partners = partners.filter((partner) =>
          partner.name.toLowerCase().includes(value) ||
          partner.description.toLowerCase().includes(value)
        );

      }

      if (this.filterData?.region && this.filterData.region !== "All") {

        partners = partners.filter(
          (partner) => partner.region === this.filterData.region
        );

      }

      return partners;

    }

  },

  methods: {

    ...mapActions(["scrollTop", "fetchPartnerProfileList"]),


async fetchPartners() {

  const skip = (this.page - 1) * this.perPage;

  const res = await this.fetchPartnerProfileList({
    skip,
    limit: this.perPage
  });

  this.total = res.total;

},
pagechanged(pageNumber) {
  this.page = pageNumber;
  const skip = (this.page - 1) * this.perPage;
  this.fetchPartnerProfileList({
    skip,
    limit: this.perPage
  });
},

    truncateText(htmlText) {

      const text = htmlText.replace(/<[^>]*>?/gm, "");
      const limit = 120;

      return text.length > limit
        ? text.substring(0, limit) + "..."
        : text;

    },

    openDescription(partner) {
      this.selectedPartner = partner;
      this.showModal = true;
    },

    closeDescriptionModal() {
      this.showModal = false;
      this.selectedPartner = null;
    },

    viewPartnerInfo(partner) {

      const url = new URL(partner.doc_link?.partner_document_web_url);
      const parts = url.pathname.split("/");

      parts[parts.length - 1] = "index.html";

      url.pathname = parts.join("/");

      this.$router.push(
        `/tfm/partner/directory/${partner.id}?link=${url.toString()}`
      );

    },

    additionalBadges(partner) {
      return partner.badge.slice(1);
    },

    getBadgeColor(index) {

      const colors = [
        "success",
        "warning",
        "info",
        "primary",
        "danger",
        "secondary",
        "dark"
      ];

      return colors[index] || "info";

    }

  },

  mounted() {
    this.scrollTop();
    this.page = parseInt(this.$route.query.page || 1);
    this.fetchPartners();
  }

};
</script>

<style scoped lang="scss">
.partner-logo {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: fill;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.read-link {
  color: #3399ff;
  cursor: pointer;
  margin-left: 5px;
  font-weight: 500;
}

.tooltip-badge-list {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  top: 100%;
  left: 0;
  z-index: 1000;
  width: max-content;
}

.badge-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 200px;
}

.banner {
  text-align: center;
  background-color: #3399ff;
  font-weight: 400;
  margin-left: -10px;
  margin-right: -10px;
  color: #fff;
}

.banner a {
  font-size: 20px !important;
  color: #331e94 !important;
  font-weight: 600 !important;
}

.title-new {
  margin-left: -10px;
}


.partner-modal-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 12px;
}


.partner-modal-content {
  max-height: 420px;
  overflow-y: auto;
  padding: 10px 5px;
}

.partner-modal-description {
  font-size: 14px;
  line-height: 1.8;
  color: #444;
}

.partner-modal-description b,
.partner-modal-description strong {
  font-weight: 600;
}
</style>